import HTTP from "@/_helpers/http";
import { CRYPTOADDRESS__API } from "@/_helpers/urls";
import { CRYPTOADDRESS__MUTATIONS } from "../mutation-types";
import { CRYPTOADDRESS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// Utility function to filter out null or undefined fields
function filterObject(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
}

// State
const state = {
  cryptoaddress: [],
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [CRYPTOADDRESS__MUTATIONS.GETCRYPTOADDRESS](state, data) {
    state.cryptoaddress = data;
  },
};

// Actions
const actions = {
  async [CRYPTOADDRESS__ACTIONS.GETCRYPTOADDRESS]({ commit, state }) {
    try {
      const url = `${CRYPTOADDRESS__API.GETCRYPTOADDRESS}`;
      const response = await HTTP().get(url);

      commit(CRYPTOADDRESS__MUTATIONS.GETCRYPTOADDRESS, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [CRYPTOADDRESS__ACTIONS.CREATECRYPTOADDRESS]({ dispatch }, parameter) {
    try {
      const formData = new FormData();

      const filteredParameter = filterObject(parameter);

      for (const [key, value] of Object.entries(filteredParameter)) {
        formData.append(key, value);
      }

      const response = await HTTP().post(
        CRYPTOADDRESS__API.CREATECRYPTOADDRESS,
        formData
      );

      if (response.status === 201) {
        toast.success("Successfully Created");
        await dispatch(CRYPTOADDRESS__ACTIONS.GETCRYPTOADDRESS);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to create");
    }
  },

  async [CRYPTOADDRESS__ACTIONS.UPDATECRYPTOADDRESS]({ dispatch }, parameter) {
    try {
      const formData = new FormData();

      const fields = ["id", "network", "address", "file_url"];

      for (const field of fields) {
        if (parameter[field]) {
          formData.append(field, parameter[field]);
        }
      }

      const response = await HTTP().patch(
        CRYPTOADDRESS__API.UPDATECRYPTOADDRESS,
        formData
      );

      if (response.status === 200) {
        toast.success("Successfully Updated");
        await dispatch(CRYPTOADDRESS__ACTIONS.GETCRYPTOADDRESS);
      }
    } catch (error) {
      console.error("Error updating server config:", error);
      toast.error(error.response.data.message);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
